import React, { useImperativeHandle, useState } from 'react';
import {
    View,
    ScrollView,
    Text
} from 'react-native-web';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';

// Lotties
import * as animationData from '../../lotties/lottie_cant_make_it.json'

// Custom Components
import { Button, InScreenModal } from '../../components';

// Utils
import { showAlert } from '../../utils/util_helpers';

// Configs
import GLOBAL from '../../configs/config_global';

function CateringCannotMakeIt(props, ref) {
    const {
        clientEmail,
        clientPhone,
        clientName
    } = props;

    // region Local State
    const [visible, setVisible] = useState(false);
    // endregion

    // region Function - Show/Hide Modal
    const showModal = () => setVisible(true);
    const hideModal = () => setVisible(false);
    // endregion

    // region Expose Methods
    useImperativeHandle(
        ref,
        () => ({ showModal, hideModal }),
        []
    )
    // endregion

    // region MAIN RENDER
    return(
        <InScreenModal visible={visible} style={{ marginHorizontal: '5%', marginVertical: '5%', backgroundColor: 'transparent', borderColor: 'transparent' }}>
            {/* Main Content */}
            <ScrollView
                style={{ width: '100%', flex: 1, backgroundColor: 'transparent' }}
                contentContainerStyle={{ paddingHorizontal: '15%' }}
                showsVerticalScrollIndicator={false}>
                {/* Title */}
                <View style={{ width: '100%', paddingHorizontal: 8, paddingVertical: 16, backgroundColor: GLOBAL.COLOR.MAIN, borderTopLeftRadius: 8, borderTopRightRadius: 8, overflow: 'hidden' }}>
                    <Text style={{ color: 'white', fontWeight: 'bold', fontSize: 15, textAlign: 'center' }}>
                        Your truck can't make it to the event
                    </Text>
                </View>

                {/* Main View */}
                <View style={{
                    width: '100%', backgroundColor: 'white', paddingVertical: 24, flexDirection: 'row', alignItems: 'center',
                    borderBottomRightRadius: 8, borderBottomLeftRadius: 8, borderWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER, overflow: 'hidden'
                }}>
                    {/* Left View */}
                    <View style={{ flex: 1 }}>
                        {/* Lottie */}
                        <Lottie
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: animationData,
                                rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
                            }}
                            width={400}
                            height={240}
                            isStopped={false}
                            isPaused={false}
                        />

                        {/* Description */}
                        <View style={{ marginTop: 32, width: '100%', paddingHorizontal: 32 }}>
                            <Text style={{ color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, textAlign: 'center', fontSize: 18, lineHeight: 28 }}>
                                Contact the client ASAP if you haven't already and let them know you can't make it.
                                {'\n\n'}
                                Contact Truckster if you need help finding a replacement.
                            </Text>
                        </View>
                    </View>

                    {/* Buttons */}
                    <View style={{ width: 300, marginRight: 32 }}>
                        {/* Email Client */}
                        <Button
                            onPress={() => {
                                hideModal();
                                if (clientEmail) {
                                    window.open(`mailto:${clientEmail}?subject=${'Unable to make it to the event'}&body=${`Hello ${clientName},`}`, '_blank');
                                }
                                else showAlert({ text: 'No email address found for this client' })
                            }}
                            backgroundColor={'white'}
                            style={{ width: '100%', marginTop: 8, borderRadius: 8, borderWidth: 2, borderColor: GLOBAL.COLOR.DIVIDER }}
                            text={'Email Client'}
                            textColor={'black'}
                        />

                        {/* Call Client */}
                        <Button
                            onPress={() => {
                                hideModal();
                                if (clientPhone) {
                                    window.open(`tel:${clientPhone}`, '_blank');
                                }
                                else showAlert({ text: 'No phone number found for this client' })
                            }}
                            backgroundColor={'white'}
                            style={{ width: '100%', marginTop: 8, borderRadius: 8, borderWidth: 2, borderColor: GLOBAL.COLOR.DIVIDER }}
                            text={'Call Client'}
                            textColor={'black'}
                        />

                        {/* Contact Truckster */}
                        <Button
                            onPress={() => {
                                hideModal();
                                window.open(`mailto:vendor.support@gotruckster.com?subject=${'Lead Replacement Requested'}&body=${'Hello Truckster,\n\nI would like to request a replacement for the following lead:\n\n'}`, '_blank');
                            }}
                            backgroundColor={GLOBAL.COLOR.MAIN}
                            style={{ width: '100%', marginTop: 8, borderRadius: 8 }}
                            text={'Contact Truckster'}
                            textColor={'white'}
                        />
                    </View>
                </View>
            </ScrollView>
        </InScreenModal>
    );
    // endregion
}

// Forward Ref
CateringCannotMakeIt = React.forwardRef(CateringCannotMakeIt);

// region Props
CateringCannotMakeIt.propTypes = {
    clientEmail: PropTypes.string,
    clientPhone: PropTypes.string,
    clientName: PropTypes.string
}

CateringCannotMakeIt.defaultProps = {
    clientEmail: '',
    clientPhone: '',
    clientName: ''
}
// endregion

export default CateringCannotMakeIt;
